import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const DomainQueryIosPrivacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a192f] via-[#112240] to-[#0a192f]">
      <Helmet>
        <title>DomainQuery - iOS Privacy Policy</title>
      </Helmet>

      {/* Header */}
      <div className='w-full h=[80px] flex justify-between items-center px-4 py-2 text-gray-300'>
        <div>
          <Link to="/" className='text-4xl font-bold md:flex hover:text-blue-400 transition duration-300'>
            Ahnaf Mahmud
          </Link>
        </div>
      </div>
      
      {/* Main Content Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold text-white mb-8">DomainQuery for iOS Privacy Policy</h1>
          
          <div className="space-y-6 text-gray-300">
            <p>
              Thank you for using the DomainQuery app. By using this application, you agree to the terms outlined in this privacy policy.
            </p>

            <p>
              The DNS feature of the app uses dnssd to resolve domains using the system DNS resolver. The WHOIS and RDAP features directly contact the relevant servers to fetch any available data. The developer cannot see which domains are being queried.
            </p>

            <p>
              The WHOIS and RDAP features only display data that is available publicly. Some domains may have WHOIS privacy enabled and so data available for such may be limited. Additionally, not all domains will have WHOIS/RDAP data available.
            </p>

            <p>
              Should you have any questions regarding this policy, please email <a href="mailto:mail@ahnafmahmud.com" className="text-blue-400 hover:text-blue-300">mail@ahnafmahmud.com</a>.
            </p>

            <p className="mt-8 text-sm">
              Last updated: 15 May 2025
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-16 pt-8 border-t border-gray-700">
          <p className="text-gray-400">
            © 2025 Ahnaf Mahmud
          </p>
        </div>
      </div>
    </div>
  );
};

export default DomainQueryIosPrivacy;
